// alerts errors

// api requests
export const errorOnSendSNSSubscriptionVerification = () => {
  alert("Error sending alert setting verification email")
}

export const errorOnSendSESEmailVerification = () => {
  alert("Error sending alert setting verification email")
}

export const errorOnSNSUnsubscription = () => {
  alert("Error unsubscribing from alert setting")
}

export const errorOnSaveAlertSetting = () => {
  alert("Error saving alert setting")
}

export const errorOnDeleteAlertSetting = () => {
  alert("Error deleting alert setting")
}